import { render, staticRenderFns } from "./PolicyDocumentList.vue?vue&type=template&id=44504589&"
import script from "./PolicyDocumentList.vue?vue&type=script&lang=js&"
export * from "./PolicyDocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports